<template>
    <div id="app">
        <v-app id="inspire">
            <v-card v-model="show" color="#FFFF99">
                <v-card-title>
                    <v-icon large left>mdi-wrench-clock</v-icon>
                    <h6>Equipo y Herramientas - Listado</h6>
                </v-card-title>
                <v-card-text class="pt-2">
                    <v-row dense>
                        <v-col cols="6" sm="6" md="4">
                            <v-select dense v-model="filtroestado" :items="estado" label="Estado" item-text="detalle"
                                item-value="valor"></v-select>
                        </v-col>
                        <v-col cols="6" sm="6" md="4">
                            <v-text-field label="Filtro por Código" dense v-model="filtrocodigo">
                            </v-text-field>
                        </v-col>
                        <v-col cols="6" sm="6" md="4">
                            <v-text-field label="Filtro por Detalle" dense v-model="filtrodetalle">
                            </v-text-field>
                        </v-col>
                    </v-row>
                    <v-row align="center" justify="space-around">
                        <v-btn tile color="success" @click="cargarListados()">
                            <v-icon left> mdi-magnify </v-icon>
                            Buscar
                        </v-btn>

                        <v-btn tile color="red" @click="editarDeposito('')">
                            <v-icon left> mdi-pencil </v-icon>
                            Nuevo
                        </v-btn>
                    </v-row>
                </v-card-text>
            </v-card>

            <v-data-table dense :headers="headers" :items="listado" :single-expand="true" locale="es-ar" class="elevation-1"
                :items-per-page="20" :footer-props="{
                    itemsPerPageText: 'equipos por página',
                }">
                <template v-slot:item.activo="{ item }">
                    <h6 v-if="item.activo == 'A'">Activo</h6>
                    <h6 v-if="item.activo == 'I'">Inactivo</h6>
                </template>
                <template v-slot:item.actions="{ item }">
                    <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                            <v-icon small color="purple" class="mr-2" v-on="on" v-bind="attrs"
                                @click.stop="editarDeposito(item)">
                                mdi-pencil
                            </v-icon>
                        </template>
                        <span>Editar Equipo</span>
                    </v-tooltip>
                </template>
            </v-data-table>
            <EditarDeposito :visible="showEditar" :codgral="editedItem.codigo" @close="showEditar = false">
            </EditarDeposito>
        </v-app>
    </div>
</template>
  
<script>
import axios from "../../../axios-auth";
import EditarDeposito from "../EquiposyHerramientas/Depositos.vue";
export default {
    components: { EditarDeposito },
    data: (vm) => ({
        editedItem: {},
        editedIndex: -1,
        filtroestado: "A",
        filtrocodigo: "",
        filtrodetalle: "",
        listado: [],
        showEditar: false,
        valid: false,
        lazy: false,
        estado: [
            { detalle: "Todos", valor: "" },
            { detalle: "Activos", valor: "A" },
            { detalle: "Inactivos", valor: "I" },
        ],

        headers: [

            { text: "Código", align: "center", sortable: false, value: "codigo" },
            { text: "Descripción", value: "detalle", sortable: false },
            { text: "Responsable", value: "responsable", sortable: false },
            { text: "Dirección", value: "direccion", sortable: false },
            { text: "Estado", value: "activo", sortable: false },
            { text: "Acciones", value: "actions", align: "center", sortable: false },
        ],
    }),

    computed: {
        show: {
            get() {
                // this.cargarListados();
                return this.visible;
            },
            set(value) {
                if (!value) {
                    this.$emit("close");
                }
            },
        },
    },

    methods: {
        cargarListados() {
            this.vaciarModels();

            const estado = this.filtroestado;
            const detalle = this.filtrodetalle;
            const codigo = this.filtrocodigo;

            let self = this;

            axios
                .get("/SSGG/CargarDepositos?", {
                    params: {
                        filtrocodigo: codigo,
                        filtroactivo: estado,
                        filtrodetalle: detalle,
                    },
                })
                .then((response) => {
                    self.listado = response.data;
                })
                .catch((error) => {
                    self.listado = [];
                    console.log(error);
                });
        },

        editarDeposito(item) {
            this.editedIndex = this.listado.indexOf(item);
            this.editedItem = Object.assign({}, item);
            this.showEditar = true;
        },
        vaciarModels() {
            this.listado = [];
        },
    },
};
</script>
  